<template>
  <div class="bet-slip bet-slip-straight">
    <div class="bet-slip-content" :class="{'bgColorWhite' : isScanningCodeForMobile}">
      <div class="bet-scroll-wrapper">
        <bet-alert-message
          v-if="!betOptionsResponse.IsSuccess"
          :description="parseBetErrorMessage(betOptionsResponse)"
        />
        <div
          v-for="(bet, index) in getStraights().Selections"
          :key="bet.OutComeId"
          v-if="betOptionsResponse.IsSuccess"
          class="bet-slip-item-wrapper"
        >
          <bet-alert-message
            v-if="!bet.error.IsSuccess"
            :description="parseBetErrorMessage(bet.error)"
            :canClose="true"
            @onRemove="removeBetFromSlipByIndex(bet.OutComeId)"
          />
          <bet-slip-selection
            v-else
            :key="bet.OutComeId"
            :selection="bet"
            :showBuyPoints="true"
            :isChecked="true"
            :show-checkbox="showCheckbox"
            @onBuyPointChange="onRiskChange(bet)"
            @onRemove="removeBetFromSlipByIndex(bet.OutComeId)"
            @accept="onRiskChange(bet)"
            @lineChecked="lineChecked(bet, $event)"
          >
            <bet-slip-risk-input
              :amount.sync="bet.input_risk_amount"
              @change="onRiskChange(bet)"
              :min="getRiskInputMinAmount(bet)"
              :max="getBetMaxLimit(bet)"
              type="RISK"
              :limit-control="hasError('RISK', bet)"
              :is-custom-limit-control="true"
            ></bet-slip-risk-input>
            <bet-slip-risk-input
              :amount.sync="bet.input_win_amount"
              :riskedAmount.sync="bet.input_risk_amount"
              @change="onWinChange(bet)"
              :min="getRiskInputMinAmount(bet)"
              :max="getMaxPayoutLimit(bet)"
              type="WIN"
              :limit-control="hasError('WIN', bet)"
              :is-custom-limit-control="true"
            ></bet-slip-risk-input>
          </bet-slip-selection>
          <div
            class="betslip-input-error error-1"
            v-if="minErrorCondition(bet) && !minBetConditionByBet(bet)"
            v-html="betSlipMinError(getBetMinLimit(bet), bet)"
          ></div>
          <div
            class="betslip-input-error error-2"
            v-if="maxErrorCondition(bet) && !minBetConditionByBet(bet)"
            v-html="betSlipMaxError(getBetMaxLimit(bet), bet)"
          ></div>
          <div
            class="betslip-input-error error-3"
            v-if="minBetConditionByBet(bet)"
            v-html="minBetConditionError()"
          ></div>
        </div>
      </div>

      <!--
      <quick-parlay-content ref="quick_parlay"></quick-parlay-content>
      <quick-round-robin-content ref="quick_round_robin" />
      <quick-teaser-content ref="quick_teaser"></quick-teaser-content>
      -->

      <div class="sticky-wrapper">
        <div
          class="bet-slip-item-wrapper append-left mb-0 set-amount-all-bets-input"
          style="border-bottom: none"
          v-if="freeWagersViewing === false"
        >
          <div class="row d-flex align-items-center">
            <div class="col-6">
              <span class="input-span" v-html="$t('BetSlip.Set Amount All Bets').replace('<br>', ' ')"></span>
            </div>

            <div class="col-6">
              <input
                :type="editAbleAllAmount ? 'tel' : 'text'"
                class="form-control bet-slip-form-control w-100"
                @blur="
                  editAbleAllAmount = false;
                  vk_hide();
                "
                @focus="
                  editAbleAllAmount = true;
                  vk_show($event);
                "
                :class="{ filled: !!allBetAmount }"
                :value="editAbleAllAmount || !allBetAmount ? allBetAmount : currencySymbol + '' + allBetAmount"
                @input="
                  allBetAmount = $event.target.value;
                  setAmountToAll();
                "
                :placeholder="$t('Risk') + ' ' + currencySymbol"
                onkeydown="return event.keyCode !== 69"
                @keypress="isNumber"
              />
            </div>
          </div>
        </div>

        <total-amounts
          class="mt-1"
          :totalBets="getTotalBetsCount()"
          :totalRiskAmount="getTotalRiskAmount()"
          :totalRiskAmountWithoutTax="getTotalRiskAmountWithoutTax()"
          :totalWinAmount="getTotalWinAmount()"
          :showFreePlayIfEligible="true"
          :betOptionsResponse="getStraights()"
          :disable-place-bet-button="disablePlaceBetButton"
          :wagerType="getWagerType()"
        ></total-amounts>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import BetSlipMixin from './bet-slip-mixin';
import { roundAmount } from '@/views/sports/components/bet-slip/bet-slip-utils';

export default {
  mixins: [BetSlipMixin],
  data() {
    return {
      allBetAmount: '',
      editAbleAllAmount: false,
    };
  },
  computed: {
    ...mapState({
      betTabs: state => state.betSlip.betTabs,
      selectedLocale: state => state.settings.selectedLocale,
      betOptionsResponse: state => state.betSlip.betOptionsResponse,
      activeFreeBet: state => state.betSlip.activeFreeBet,
      isScanningCodeForMobile: state => state.settings.isScanningCodeForMobile,
    }),
    ...mapGetters('player', ['currency', 'currencySymbol']),
    disablePlaceBetButton() {
      return this.getStraights().Selections.some(bet => {
        return (
          this.minErrorCondition(bet) ||
          this.maxErrorCondition(bet) ||
          this.minBetConditionByBet(bet) ||
          !bet.error.IsSuccess
        );
      });
    },
  },
  methods: {
    ...mapMutations('helper', ['vk_show', 'vk_hide']),
    ...mapMutations({
      setNewBetOptionsResponse: 'betSlip/setNewBetOptionsResponse',
      setBetOptionsResponse: 'betSlip/setBetOptionsResponse',
    }),

    getWagerType() {
      return 'straight';
    },

    onRiskChange(bet) {
      if (!bet) return;
      bet.input_win_amount = this.roundAmount(bet.input_risk_amount * this.americanToDecimal(bet.Odd));
      this.notifyBetSlip(bet);
      this.setNewBetOptionsResponse(bet);
    },
    onWinChange(bet) {
      if (!bet) return;
      bet.input_risk_amount = this.roundAmount(bet.input_win_amount / this.americanToDecimal(bet.Odd));
      this.notifyBetSlip(bet);
    },
    notifyBetSlip(bet) {
      if (this.$taxHelper.mustApplyTax) {
        const input_risk_amount = bet.input_risk_amount;
        if (input_risk_amount != '') {
          const appliedTaxToWinInputHidden =
            this.$taxHelper.applyTaxToRiskInputHidden({
              input_risk_amount,
            }) * this.americanToDecimal(bet.Odd);

          bet.input_win_amount = this.roundAmount(appliedTaxToWinInputHidden);
        }
      }

      this.createOrUpdateBet(
        this.createBet(bet.type, bet.OutComeId, bet.input_risk_amount, bet.input_win_amount, 0, 0, null),
      );
    },
    setAmountToAll() {
      if (this.getStraights()) {
        this.getStraights().Selections.forEach(bet => {
          bet.input_risk_amount = this.allBetAmount;
          this.onRiskChange(bet);
        });
      }
    },
    getTotalRiskAmount() {
      if (this.activeFreeBet) {
        return 0;
      }
      let total = 0;
      if (this.getCheckedStraights()) {
        this.getCheckedStraights().Selections.forEach(bet => {
          if (bet.input_risk_amount) {
            const input_risk_amount = parseFloat(bet.input_risk_amount);
            total += parseFloat(
              this.$taxHelper.applyTaxToRiskInputHidden({
                input_risk_amount,
              }),
            );
          }
        });
      }

      return this.roundAmount(total);
    },
    getTotalRiskAmountWithoutTax() {
      let total = 0;
      if (this.getCheckedStraights()) {
        this.getCheckedStraights().Selections.forEach(bet => {
          if (bet.input_risk_amount !== '') {
            const input_risk_amount = parseFloat(bet.input_risk_amount);
            total += input_risk_amount;
          }
        });
      }
      return this.roundAmount(total);
    },
    getTotalWinAmount() {
      let total = 0;
      if (this.getCheckedStraights()) {
        this.getCheckedStraights().Selections.forEach(bet => {
          if (this.activeFreeBet)
            total += bet.input_win_amount === '' ? 0 : parseFloat(bet.input_win_amount - bet.input_risk_amount);
          else total += bet.input_win_amount === '' ? 0 : parseFloat(bet.input_win_amount);
        });
      }

      return this.roundAmount(total);
    },
    getTotalBetsCount() {
      let total = 0;
      total += this.getCheckedStraights()
        ? this.getCheckedStraights().Selections.filter(bet => parseFloat(bet.input_win_amount) > 0).length
        : 0;
      return total;
    },
    triggerRiskChangeForAllBets() {
      if (this.getCheckedStraights()) {
        this.getCheckedStraights().Selections.map(bet => this.onRiskChange(bet));
      }
    },
    lineChecked(bet, value) {
      this.createOrUpdateBet(
        this.createBet(bet.type, bet.OutComeId, bet.input_risk_amount, bet.input_win_amount, 0, 0, null, value),
      );
    },
  },
  created() {
    // this.betOptionsResponse.input_risk_amount = null;
    // this.betOptionsResponse.input_win_amount = null;
    // this.betOptionsResponse.WagerType = 'straight';
    // this.betOptionsResponse.Selections.forEach((f) => {
    //   f.input_risk_amount = null;
    //   f.input_win_amount = null;
    // });
    // this.setBetOptionsResponse(this.betOptionsResponse);
  },
};
</script>
<style lang="scss" scoped>
input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
